import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

// Sprint 3 (Enterprise Shared Component Library): optional `loading` prop, added on top of the
// existing contract — no current caller passes it, so every existing usage is unaffected.
//
// Stage 3.2 (Enterprise Design Foundation & Layout Standardization): optional `variant` prop,
// added the same additive way — every existing caller already passes its own explicit `className`
// (e.g. "button-global button-primary autoHeight mw125 mt10"), so `variant` is only consumed when
// no `className` is given, and no existing call site's rendered className changes. When used,
// `variant` resolves to "button-global button-<variant>" (see the .button-global.button-secondary/
// -outline/-success rules added to themes.scss this sprint, alongside the existing -primary/-danger).
const Button = (props) => {
    const resolvedClassName = props.className || (props.variant ? `button-global button-${props.variant}` : props.className);
    return (
    <button
      id={props.id}
      name={props.id}
      type={props.type}
      onClick={props.onClick}
      style={props.style}
      disabled={props.disabled || props.loading}
      className={resolvedClassName}
    >{props.loading && <Icon type="loading" className="mr-2" />}{props.value}
    </button>
)
}

Button.propTypes={
  id: PropTypes.string,
  // Console-warning fix: an HTML <button> is valid with no `type` attribute (defaults to "submit", which
  // is inert here since none of this component's callers render inside a <form>) — most existing callers
  // across the codebase never pass it, so requiring it only produced a false-positive warning on every
  // one of them, never an actual defect.
  type: PropTypes.string,
  value: PropTypes.any.isRequired,
  onClick: PropTypes.any,
  style: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  variant: PropTypes.oneOf(['primary', 'secondary', 'outline', 'success', 'danger'])
};

export default Button;